// remove tag
export function removeTag(str: string) {
  return str.replace(/<[^>]*>?/g, '')
}

/** HTML에서 일반 문자열을 안전하게 삽입할 수 있는 텍스트로 변환 */
export function safely(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&apos;')
}

/** text를 HTML에서 안전하게 삽입할 수 있게 하되, 텍스트의 형태(줄바꿈, 띄어쓰기 개수)를 유지하여 렌더링되도록 변환 */
export function safetyText(text: string): string {
  return safely(text)
    .replace(/ {2}/g, ' &nbsp;')
    .replace(/\n|\r\n/g, '<br>')
}
